import {useState} from 'react'
import {useIntl} from 'react-intl'
import {useGetUser} from '../../store/userStore'
import {canViewBilling as hasBillingAccess} from '../../helpers'
import {TwilioBillingPage} from '../twilioBilling/TwilioBillingPage'
import {NumbersInventoryTab} from '../twilioBilling/NumbersInventoryTab'
import {RebillingTab} from './RebillingTab'
import {UsageByNumberTab} from './UsageByNumberTab'
import {AssignmentsTab} from './AssignmentsTab'
import {BILLING_MESSAGES as M} from './billingMessages'

// Billing hub. El acceso depende solo de view_billing / manage_billing
// (core.ProvisionedNumber), sin excepciones por rol — ni siquiera Administrador:
// la ruta /billing y el item del sidebar exigen lo mismo vía `canViewBilling`,
// así que acá no hace falta volver a discriminar. Los agentes gestionan sus
// propios números en Profile → My Numbers.
export const BillingPage = () => {
  const intl = useIntl()
  const permissions = useGetUser((s: any) => s.user?.permissions)
  const canViewBilling = hasBillingAccess(permissions || [])

  // El `key` es la clave de estado; la etiqueta se traduce. Se pintaba como
  // `{t.label}`, una variable, asi que el rule no lo veia (plan §10.8).
  const tabs: {key: string; label: string}[] = []
  if (canViewBilling) tabs.push({key: 'cost', label: intl.formatMessage(M.tabCost)})
  if (canViewBilling) tabs.push({key: 'inventory', label: intl.formatMessage(M.tabInventory)})
  if (canViewBilling) tabs.push({key: 'usage', label: intl.formatMessage(M.tabUsage)})
  if (canViewBilling) tabs.push({key: 'rebilling', label: intl.formatMessage(M.tabRebilling)})
  if (canViewBilling) tabs.push({key: 'assignments', label: intl.formatMessage(M.tabAssignments)})

  const [active, setActive] = useState<string>('')
  const current = active || tabs[0]?.key || ''

  return (
    <div className='mt-5'>
      {tabs.length > 1 && (
        <ul className='nav nav-tabs nav-line-tabs fs-6 mb-2'>
          {tabs.map((t) => (
            <li className='nav-item' key={t.key}>
              <a
                className={`nav-link ${current === t.key ? 'active' : ''}`}
                style={{cursor: 'pointer'}}
                onClick={() => setActive(t.key)}
              >
                {t.label}
              </a>
            </li>
          ))}
        </ul>
      )}
      {current === 'cost' && <TwilioBillingPage />}
      {current === 'inventory' && <NumbersInventoryTab />}
      {current === 'usage' && <UsageByNumberTab />}
      {current === 'rebilling' && <RebillingTab />}
      {current === 'assignments' && <AssignmentsTab />}
    </div>
  )
}
